import {Stack} from '@mui/material'
import React from 'react'
import Label from './Label'
import {useNavigate} from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      flexWrap={'wrap'}
      gap='60px'
      direction={'row'}
    >
      <svg
        width='386'
        height='386'
        viewBox='0 0 386 386'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clip-path='url(#clip0_15015_88652)'>
          <circle cx='183.28' cy='189.311' r='183.28' fill='#F5F8FF' />
          <circle cx='183.286' cy='189.311' r='142.551' fill='#E4ECFE' />
          <path
            d='M268.478 311.961H98.4757C94.0536 311.961 90.4688 308.376 90.4688 303.954V74.3507C90.4688 69.9286 94.0536 66.3438 98.4758 66.3438H231.216L276.485 108.131V303.954C276.485 308.376 272.9 311.961 268.478 311.961Z'
            fill='#F5F8FF'
            stroke='#B7CEFF'
            stroke-width='6.03125'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M110.93 117.681C110.93 114.637 113.397 112.17 116.441 112.17H223.154C226.198 112.17 228.666 114.637 228.666 117.681C228.666 120.725 226.198 123.193 223.154 123.193H116.441C113.397 123.193 110.93 120.725 110.93 117.681ZM110.93 151.652C110.93 148.608 113.397 146.141 116.441 146.141H254.136C257.179 146.141 259.647 148.608 259.647 151.652C259.647 154.696 257.179 157.163 254.136 157.163H116.441C113.397 157.163 110.93 154.696 110.93 151.652ZM110.93 185.623C110.93 182.579 113.397 180.111 116.441 180.111H154.307C157.351 180.111 159.818 182.579 159.818 185.623C159.818 188.666 157.351 191.134 154.307 191.134H116.441C113.397 191.134 110.93 188.666 110.93 185.623ZM172.892 185.623C172.892 182.579 175.36 180.111 178.404 180.111H254.136C257.179 180.111 259.647 182.579 259.647 185.623C259.647 188.666 257.179 191.134 254.136 191.134H178.404C175.36 191.134 172.892 188.666 172.892 185.623ZM110.93 219.593C110.93 216.55 113.397 214.082 116.441 214.082H216.27C219.313 214.082 221.781 216.55 221.781 219.593C221.781 222.637 219.313 225.105 216.27 225.105H116.441C113.397 225.105 110.93 222.637 110.93 219.593ZM234.855 219.593C234.855 216.55 237.322 214.082 240.366 214.082H254.136C257.179 214.082 259.647 216.55 259.647 219.593C259.647 222.637 257.179 225.105 254.136 225.105H240.366C237.322 225.105 234.855 222.637 234.855 219.593ZM110.93 250.167C110.93 247.123 113.397 244.656 116.441 244.656H243.808C246.852 244.656 249.32 247.123 249.32 250.167C249.32 253.211 246.852 255.678 243.808 255.678H116.441C113.397 255.678 110.93 253.211 110.93 250.167ZM110.93 280.741C110.93 277.697 113.397 275.229 116.441 275.229H209.385C212.429 275.229 214.896 277.697 214.896 280.741C214.896 283.784 212.429 286.252 209.385 286.252H116.441C113.397 286.252 110.93 283.784 110.93 280.741Z'
            fill='#B7CEFF'
          />
          <path
            d='M110.93 117.681C110.93 114.637 113.397 112.17 116.441 112.17H223.154C226.198 112.17 228.666 114.637 228.666 117.681C228.666 120.725 226.198 123.193 223.154 123.193H116.441C113.397 123.193 110.93 120.725 110.93 117.681Z'
            fill='#405189'
          />
          <path
            d='M232.391 63.3281L279.497 106.811H244.453C237.791 106.811 232.391 101.41 232.391 94.7481V63.3281Z'
            fill='#B7CEFF'
          />
          <rect
            width='44.4177'
            height='7.65822'
            rx='3.82911'
            transform='matrix(-0.707107 0.707107 0.707107 0.707107 61.5625 69.3594)'
            fill='#405189'
          />
          <rect
            width='44.4177'
            height='7.65822'
            rx='3.82911'
            transform='matrix(0.707107 0.707107 0.707107 -0.707107 30.1562 74.7754)'
            fill='#405189'
          />
          <circle cx='79.4352' cy='175.935' r='13.0914' stroke='#405189' stroke-width='12.0625' />
          <circle cx='351.645' cy='215.942' r='10.8796' stroke='#405189' stroke-width='12.0625' />
          <circle cx='30.4882' cy='238.566' r='3.34758' stroke='#405189' stroke-width='9.04688' />
          <path
            d='M189.732 379.842C255.69 379.842 309.16 376.72 309.16 372.869C309.16 369.018 255.69 365.896 189.732 365.896C123.774 365.896 70.3047 369.018 70.3047 372.869C70.3047 376.72 123.774 379.842 189.732 379.842Z'
            fill='#B7CEFF'
          />
          <path
            d='M252.529 270.738L270.474 252.793L344.419 315.907C353.476 323.637 354.02 337.446 345.601 345.865C337.182 354.284 323.373 353.739 315.643 344.683L252.529 270.738Z'
            fill='#405189'
          />
          <path
            d='M265.27 285.664L315.643 344.682C323.373 353.739 337.182 354.283 345.601 345.864C354.02 337.445 353.476 323.636 344.419 315.906L278.537 259.674C275.886 269.232 271.323 278.032 265.27 285.664Z'
            fill='#405189'
          />
          <path
            d='M232.047 163.055L185.665 270.737C184.95 270.185 184.242 269.612 183.547 269.033C179.065 265.242 175.161 260.788 171.965 255.818L212.028 162.805C218.665 161.712 225.437 161.796 232.047 163.055Z'
            fill='white'
          />
          <path
            d='M265.011 181.736L221.403 282.979C212.345 282.989 203.406 280.869 195.277 276.782L242.895 166.225C251.331 169.598 258.897 174.904 265.011 181.736Z'
            fill='white'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M194.889 177.94C186.444 183.436 179.755 191.388 175.696 200.812C171.636 210.238 170.397 220.694 172.146 230.852C173.895 241.009 178.547 250.384 185.487 257.799C192.425 265.212 201.334 270.333 211.077 272.544C220.818 274.755 230.983 273.965 240.294 270.268L240.295 270.267C246.48 267.812 252.143 264.13 256.956 259.423C261.771 254.715 265.64 249.074 268.336 242.817C271.031 236.559 272.497 229.814 272.645 222.966C272.792 216.118 271.618 209.312 269.194 202.937L269.194 202.936C265.544 193.334 259.202 185.085 250.999 179.21C242.799 173.337 233.1 170.095 223.128 169.87C213.158 169.645 203.331 172.446 194.889 177.94ZM160.091 194.09C165.459 181.63 174.333 171.046 185.62 163.7C196.91 156.352 210.097 152.58 223.512 152.883C236.927 153.186 249.935 157.549 260.892 165.396C271.847 173.242 280.253 184.212 285.076 196.899C288.279 205.323 289.826 214.305 289.631 223.332C289.437 232.36 287.505 241.264 283.94 249.539C280.376 257.814 275.246 265.302 268.836 271.571C262.425 277.839 254.859 282.766 246.565 286.059C234.072 291.02 220.41 292.086 207.316 289.114C194.224 286.142 182.314 279.274 173.082 269.409C163.851 259.546 157.708 247.128 155.402 233.735C153.096 220.343 154.725 206.549 160.091 194.09Z'
            fill='#405189'
          />
          <path
            d='M337.794 316.495L284.518 272.87C282.867 271.518 280.943 273.42 282.28 275.083L325.3 328.59C326.96 330.655 329.357 331.996 331.854 332.257L333.331 332.411C338.432 332.945 342.27 328.913 341.518 323.812L341.343 322.625C340.999 320.286 339.714 318.068 337.794 316.495Z'
            fill='#9FBDFF'
          />
          <rect
            width='69.1137'
            height='11.9162'
            rx='5.95808'
            transform='matrix(-0.707107 0.707107 0.707107 0.707107 241.875 193)'
            fill='#405189'
          />
          <rect
            width='69.1137'
            height='11.9162'
            rx='5.95808'
            transform='matrix(0.707107 0.707107 0.707107 -0.707107 193 201.424)'
            fill='#405189'
          />
          <rect
            width='38.6011'
            height='6.65535'
            rx='3.32768'
            transform='matrix(-0.707107 0.707107 0.707107 0.707107 334.887 117.609)'
            fill='#405189'
          />
          <rect
            width='38.6011'
            height='6.65535'
            rx='3.32768'
            transform='matrix(0.707107 0.707107 0.707107 -0.707107 307.594 122.315)'
            fill='#405189'
          />
          <rect
            width='32.7379'
            height='5.64446'
            rx='2.82223'
            transform='matrix(-0.707107 0.707107 0.707107 0.707107 134.727 328.703)'
            fill='#405189'
          />
          <rect
            width='32.7379'
            height='5.64446'
            rx='2.82223'
            transform='matrix(0.707107 0.707107 0.707107 -0.707107 111.578 332.695)'
            fill='#405189'
          />
        </g>
        <defs>
          <clipPath id='clip0_15015_88652'>
            <rect width='386' height='386' fill='white' />
          </clipPath>
        </defs>
      </svg>
      <Stack>
        <Label color='#405189' fs='60px' fw='500' text='404 not found' />
        <Label color='#405189' fs='28px' fw='500' text='Looking something we don’t serve?' />
        <Stack gap='24px' direction={'row'}>
          <Stack
            onClick={() => {
              navigate('/')
            }}
            sx={{cursor: 'pointer'}}
            borderBottom={'1px solid #009EF7'}
          >
            <Label color='#009EF7' fs='23px' fw='400' text='back to home' />
          </Stack>
          <Stack
            onClick={() => {
              navigate('/')
            }}
            sx={{cursor: 'pointer'}}
            borderBottom={'1px solid #009EF7'}
          >
            <Label color='#009EF7' fs='23px' fw='400' text='contact us' />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
